(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-mega-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('header-megamenu')) {
    class HeaderMegaMenu extends HTMLElement {
      constructor() {
        super();
        this.content = null;
        this.overlay = null;
        this.hideTimeout = null;
        this.showTimeout = null;
      }

      connectedCallback() {
        this.content = this.querySelector('.mega-menu__content');
        if (!this.content) return;

        this.overlay = this.createOverlay();
        this.addEventListener('mouseenter', this.show.bind(this));
        this.addEventListener('mouseleave', this.hide.bind(this));
      }

      createOverlay() {
        if (document.querySelector('.megamenu-overlay')) {
          return document.querySelector('.megamenu-overlay');
        }
        const overlay = document.createElement('div');
        overlay.classList.add('megamenu-overlay');
        Object.assign(overlay.style, {
          position: 'fixed',
          inset: '0',
          backgroundColor: 'rgba(0, 0, 0, 0.3)',
          opacity: '0',
          visibility: 'hidden',
          transition: 'opacity 0.25s cubic-bezier(0.25, 0.1, 0.25, 1), visibility 0.25s',
          zIndex: '1',
          pointerEvents: 'none'
        });
        document.body.appendChild(overlay);
        return overlay;
      }

      show() {
        clearTimeout(this.hideTimeout);
        clearTimeout(this.showTimeout);
        this.showTimeout = setTimeout(() => {
          this.content.style.display = 'flex';
          this.overlay.style.display = 'block';
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              this.content.style.visibility = 'visible';
              this.content.style.transition = 'opacity 0.35s ease-out';
              this.content.style.opacity = '1';
              this.overlay.style.visibility = 'visible';
              this.overlay.style.transition = 'opacity 0.35s ease-out';
              this.overlay.style.opacity = '1';
            });
          });
        }, 250);
      }

      hide() {
        clearTimeout(this.showTimeout);
        this.hideTimeout = setTimeout(() => {
          this.content.style.transition = 'opacity 0.08s ease-out, visibility 0.08s';
          this.overlay.style.transition = 'opacity 0.08s ease-out, visibility 0.08s';
          this.content.style.opacity = '0';
          this.content.style.visibility = 'hidden';
          this.overlay.style.opacity = '0';
          this.overlay.style.visibility = 'hidden';
          setTimeout(() => {
            this.content.style.display = 'none';
          }, 80);
        }, 100);
      }
    }

    customElements.define('header-megamenu', HeaderMegaMenu);
  }
  } catch(e) { console.error(e); }
})();

})();
